import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const FinalCTA: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-gradient-to-br from-brand-medium to-brand-primary text-white text-center" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-56">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6" data-id="element-57">
            ¿Estás listo/a para transformar tu cocina?
          </h2>
          <p className="text-xl md:text-2xl text-brand-cream mb-10" data-id="element-58">
            Empezá hoy con COCINA VIANDERA y los 15 bonos incluidos
          </p>

          <div className="flex flex-col items-center space-y-4" data-id="element-59">
            <Button className="py-5 px-10 text-xl shadow-2xl" data-id="element-60">
              QUIERO EMPEZAR AHORA →
            </Button>
            <p className="text-lg font-bold text-brand-light pt-4" data-id="element-61">
              Solo $15.990 — Oferta por tiempo limitado
            </p>
            <p className="text-sm text-brand-cream/80" data-id="element-62">2 días de garantía</p>
          </div>
        </motion.div>
      </div>
    </section>;
};